var _defs, _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMediaIcon10(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_4658",
    "data-name": "Group 4658",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 35.68,
    height: 33.814,
    viewBox: "0 0 35.68 33.814",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1664",
    "data-name": "Rectangle 1664",
    width: 35.68,
    height: 33.814,
    fill: "#ff9ee0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4657",
    "data-name": "Group 4657",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14058",
    "data-name": "Path 14058",
    d: "M35.6,17.506a.66.66,0,0,0-.037-.22L30.079,4.477a1.253,1.253,0,0,0-.229-.342,1.341,1.341,0,0,0-1.03-.476H19.211V1.371a1.371,1.371,0,1,0-2.742,0V3.66H6.861a1.408,1.408,0,0,0-1.03.476,1.253,1.253,0,0,0-.229.342L.112,17.286a1.454,1.454,0,0,0-.037.22A2.418,2.418,0,0,0,0,17.821v1.83a6.861,6.861,0,1,0,13.722,0v-1.83a.98.98,0,0,0-.076-.325.494.494,0,0,0-.037-.227L8.947,6.366h7.522v24.7H10.521a1.372,1.372,0,0,0,0,2.745H25.16a1.372,1.372,0,0,0,0-2.745H19.211V6.4h7.522L22.071,17.286a1.455,1.455,0,0,0-.037.22,2.418,2.418,0,0,0-.076.315v1.83a6.861,6.861,0,1,0,13.722,0v-1.83A.98.98,0,0,0,35.6,17.5Zm-28.744-9,3.4,7.959H3.457Zm4.118,11.16a4.118,4.118,0,0,1-8.237,0v-.459h8.237Zm21.244-3.2H25.416l3.4-7.959Zm.715,3.2a4.118,4.118,0,0,1-8.237,0v-.459h8.237Z",
    transform: "translate(0 0)",
    fill: "#ff9ee0"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediaIcon10);
export default __webpack_public_path__ + "static/media/media_icon10.27e0e05ca59749abb36a990a06786188.svg";
export { ForwardRef as ReactComponent };